import { useEffect, useRef, useState } from "react"
import { IconButton } from "@chakra-ui/react"
import { MdKeyboardArrowUp } from "react-icons/md"
import { colors } from "../../utilities/colors"

const findScrollableParent = (node) => {
  let el = node?.parentElement
  while (el && el !== document.body) {
    const style = window.getComputedStyle(el)
    const overflowY = style.overflowY
    const isScrollable = (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay')
    if (isScrollable && el.scrollHeight > el.clientHeight) return el
    el = el.parentElement
  }
  return null
}

export default function ScrollToTopButton({ threshold = 200 }) {
  const anchorRef = useRef(null)
  const scrollerRef = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const scroller = findScrollableParent(anchorRef.current) || window
    scrollerRef.current = scroller

    const getScrollTop = () =>
      scroller === window ? window.scrollY : scroller.scrollTop

    const handleScroll = () => setVisible(getScrollTop() > threshold)

    handleScroll()
    scroller.addEventListener('scroll', handleScroll, { passive: true })
    return () => scroller.removeEventListener('scroll', handleScroll)
  }, [threshold])

  const handleClick = () => {
    const scroller = scrollerRef.current
    if (!scroller) return
    if (scroller === window) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      scroller.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  return (
    <>
      <span ref={anchorRef} style={{ display: 'none' }} aria-hidden />
      {visible && (
        <IconButton
          aria-label="Scroll to top"
          onClick={handleClick}
          position="fixed"
          bottom={{ base: 20, lg: 6 }}
          left="50%"
          transform="translateX(-50%)"
          zIndex={40}
          size="lg"
          borderRadius="full"
          bg={`${colors.grey300}80`}
          color={colors.grey900}
          boxShadow="md"
          backdropFilter="blur(4px)"
          _hover={{ bg: `${colors.grey100}99` }}
        >
          <MdKeyboardArrowUp size={32} />
        </IconButton>
      )}
    </>
  )
}
